import { render, staticRenderFns } from "./ContactButton.vue?vue&type=template&id=14079a75&scoped=true"
import script from "./ContactButton.vue?vue&type=script&lang=js"
export * from "./ContactButton.vue?vue&type=script&lang=js"
import style0 from "./ContactButton.vue?vue&type=style&index=0&id=14079a75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14079a75",
  null
  
)

export default component.exports